<div class="recipients-and-actions">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <i-tabs [items]="tabs" (tabChange)="onTabChange($event)"></i-tabs>
        <div class="d-flex align-items-center gap-2">
            <span class="mt-auto">
                <idel-toggler [value]="toggleConfig"></idel-toggler>
            </span>

            <i-button [text]="'Demander une action'" [icon]="'bi bi-rocket-takeoff-fill'" [iconPosition]="'left'"
                [styleClass]="'green'" (click)="isAddActionFormDialogOpen.set(true)"></i-button>
            <i-button [text]="'Envoyer pour information'" [icon]="'bi bi-person-fill-up'" [iconPosition]="'left'"
                [styleClass]="'green'" (click)="openAddRecipientsFormDialog()"></i-button>
        </div>
    </div>
    @if(currentTab() === 'actions') {
    <div class="recipients-and-actions__actions">
        @if(!fetchingActionsAndRecipients()) {
        <div class="mt-1 recipients-and-actions__actions__list">
            @if(currentLayout() === 'simplified') {
            @for(action of actions(); track action) {
            <idel-action-card [action]="action" [currentUser]="userInfos()" [lightMode]="true" [contacts]="contacts()"
                (onProcess)="onActionProcessClick(action)"></idel-action-card>
            }@empty {
            <idel-empty-result-placeholder [options]="emptyResultOptions"
                [emptyMessage]="'Aucune action pour le moment'"></idel-empty-result-placeholder>
            }
            }@else {
            @if(actions().length) {
            <i-table-v17 [columns]="actionsColumns()" [items]="actions()" [config]="actionsTableConfig"
                [customActions]="actionsTableActions" [menu]="actionsMenu"></i-table-v17>

            }@else {
            <idel-empty-result-placeholder [options]="emptyResultOptions"
                [emptyMessage]="'Aucune action pour le moment'"></idel-empty-result-placeholder>
            }
            }
        </div>
        }@else {
        <div class="mt-3 w-100 h-100 d-flex justify-content-center align-items-center">
            <i-loader></i-loader>
        </div>
        }
    </div>
    }@else {
    <div class="recipients-and-actions__recipients">
        @if(!fetchingActionsAndRecipients()) {
        <div class="mt-1 recipients-and-actions__actions__list">
            @if(currentLayout() === 'simplified') {
            @for(recipient of recipients(); track recipient) {
            <idel-recipient-card [recipient]="recipient" (refresh)="refreshRecipients()"
                [target]="target()"></idel-recipient-card>
            }@empty {
            <idel-empty-result-placeholder [options]="emptyResultOptions"
                [emptyMessage]="'Aucun destinataire pour le moment'"></idel-empty-result-placeholder>
            }
            }@else {
            @if(recipients().length) {
            <i-table-v17 [columns]="recipientsColumns()" [items]="recipients()" [config]="recipientsTableConfig"
                [customActions]="recipientsTableActions()" (rowSelectionChange)="onRecipientsSelectionChange($event)"
                (onRemoveSelection)="onDeleteRecipients($event)"></i-table-v17>

            }@else {
            <idel-empty-result-placeholder [options]="emptyResultOptions"
                [emptyMessage]="'Aucun destinataire pour le moment'"></idel-empty-result-placeholder>
            }
            }
        </div>
        }@else {
        <div class="mt-3 w-100 h-100 d-flex justify-content-center align-items-center">
            <i-loader></i-loader>
        </div>
        }
    </div>
    }

</div>


<p-dialog [visible]="isAddActionFormDialogOpen()" (visibleChange)="isAddActionFormDialogOpen.set($event)"
    [style]="{width: '50dvw'}" [header]="'Demander une action'">

    @if(isAddActionFormDialogOpen()) {
    <idel-add-action-form (onCancel)="isAddActionFormDialogOpen.set(false)" (onCreate)="refreshRecipients()"
        [target]="target()"></idel-add-action-form>
    }
</p-dialog>

<p-dialog [blockScroll]="true" [visible]="isActionProcessDialogOpen()"
    (visibleChange)="isActionProcessDialogOpen.set($event)" [header]="'Traiter l\'action'" [style]="{width: '30dvw'}">
    @if(actionToProcess()) {
    <idel-action-process [action]="actionToProcess()" (processed)="onActionProcessed()" [currentUser]="userInfos()"
        [scope]="target().scope === 'point' ? 'points' : 'meetings'"></idel-action-process>
    }
</p-dialog>